/* Mobile navigation — builds a hamburger menu from the existing .nav-links and
   keeps a cart icon in the top bar (never inside the hamburger).
   Self-contained: injects its own styles + markup, so each page only needs
   <script src="assets/mobile-nav.js"></script> before </body>. */
(function () {
  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">' +
    '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>' +
    '<path d="M2 3h3l2.4 12.4a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>';

  function init() {
    var nav = document.querySelector('nav.top');
    var inner = nav && nav.querySelector('.nav-inner');
    var links = inner && inner.querySelector('.nav-links');
    if (!nav || !inner || !links) return;
    if (inner.querySelector('.nav-burger')) return; // already built

    /* ---- styles ---- */
    var css = document.createElement('style');
    css.textContent = [
      '.nav-burger{display:none;flex-direction:column;justify-content:center;gap:5px;width:34px;height:34px;padding:0;background:none;border:0;cursor:pointer;z-index:60}',
      '.nav-burger span{display:block;width:24px;height:1.6px;background:var(--cream,#f3ead6);transition:transform .3s,opacity .2s;margin:0 auto}',
      '.nav-burger.open span:nth-child(1){transform:translateY(6.6px) rotate(45deg)}',
      '.nav-burger.open span:nth-child(2){opacity:0}',
      '.nav-burger.open span:nth-child(3){transform:translateY(-6.6px) rotate(-45deg)}',
      '.nav-mobile{position:absolute;left:0;right:0;top:100%;background:rgba(8,18,42,0.96);backdrop-filter:blur(14px);border-bottom:1px solid var(--line,rgba(201,169,106,0.18));border-top:1px solid var(--line,rgba(201,169,106,0.18));overflow:hidden;max-height:0;transition:max-height .35s ease;z-index:55}',
      '.nav-mobile.open{max-height:60vh}',
      '.nav-mobile a{display:block;padding:17px 32px;font-family:var(--serif,"EB Garamond",serif);font-size:19px;color:var(--ink,#cfd6e8);border-bottom:1px solid rgba(201,169,106,0.10);transition:color .2s,background .2s;text-decoration:none}',
      '.nav-mobile a:last-child{border-bottom:0}',
      '.nav-mobile a:hover,.nav-mobile a.active{color:var(--gold,#c9a96a);background:rgba(201,169,106,0.05)}',
      /* cart icon in the bar */
      '.nav-cart-bar{display:flex;align-items:center;color:var(--gold,#c9a96a);position:relative;transition:color .25s}',
      '.nav-cart-bar:hover{color:var(--cream,#f3ead6)}',
      '.nav-cart-bar svg{width:21px;height:21px}',
      '.nav-cart-injected{display:none}',            /* desktop: injected cart hidden (page already has its own chrome) */
      '@media(max-width:860px){',
      '  .nav-burger{display:flex;order:4;margin-left:18px}',
      '  .nav-links{display:none}',
      '  .nav-icons{display:none!important}',          /* hide decorative search/bookmark on mobile */
      '  .nav-cart-bar{display:flex!important;order:2;margin-left:auto}',
      '  .lang-toggle{position:absolute;top:calc(100% + 12px);right:18px;margin-left:0!important;z-index:6}',
      '}',
      '@media(min-width:861px){.nav-mobile{display:none}}'
    ].join('');
    document.head.appendChild(css);

    /* ---- cart icon in the bar (reuse the page's cart if it has one) ---- */
    var pageCart = inner.querySelector('.nav-cart'); // sits inside .nav-links on some pages
    var barCart;
    if (pageCart) {
      barCart = pageCart;
      barCart.classList.add('nav-cart-bar');
      inner.appendChild(barCart);                    // move out of nav-links, into the bar
    } else {
      barCart = document.createElement('a');
      barCart.href = '/pages/winkelwagen';
      barCart.setAttribute('aria-label', 'Winkelwagen');
      barCart.className = 'nav-cart-bar nav-cart-injected';
      barCart.innerHTML = CART_SVG;
      inner.appendChild(barCart);
    }

    /* ---- burger button ---- */
    var burger = document.createElement('button');
    burger.className = 'nav-burger';
    burger.setAttribute('aria-label', 'Menu');
    burger.setAttribute('aria-expanded', 'false');
    burger.innerHTML = '<span></span><span></span><span></span>';
    inner.appendChild(burger);

    /* ---- mobile menu (clone of the desktop links, excluding the cart) ---- */
    var menu = document.createElement('div');
    menu.className = 'nav-mobile';
    links.querySelectorAll('a').forEach(function (a) {
      if (a.classList.contains('nav-cart')) return;  // cart never goes in the hamburger
      menu.appendChild(a.cloneNode(true));
    });
    nav.appendChild(menu);

    function setOpen(open) {
      burger.classList.toggle('open', open);
      menu.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    burger.addEventListener('click', function () {
      setOpen(!menu.classList.contains('open'));
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
